module.exports = __webpack_public_path__ + "static/img/nobelisk_256.1de3ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nobelisk_256.png
// module id = eC1G
// module chunks = 0